<template>
<div>
    <div v-if="loading" class="loading-spin">
        <SpinnerLoader :color="'#3c5d3d'" />
    </div>
    <div v-if="dataNews && !loading" :style="{ 'background' : data.impairedRegime ? '#ffffff' : '#f2f2f2', 'color' : data.impairedRegime ? '#000000' : '#333333'}" class="outer flex-col">
        <div v-if="showModal" id="myModal" class="modal">
            <div class="modal-content flex-col">
                <svg @click="showModal = false;" style="position: absolute; cursor: pointer; right: 40px; top: 36px;" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 1.8L16.2 0L9 7.2L1.8 0L0 1.8L7.2 9L0 16.2L1.8 18L9 10.8L16.2 18L18 16.2L10.8 9L18 1.8Z" :fill="data.impairedRegime ? '#000000' : '#568357'"/>
                </svg>
                <h5 v-if="lang === 'ru'">Поделитесь статьей в социальных сетях</h5>
                <h5 v-if="lang === 'kk'">Мақаланы әлеуметтік желілерде бөлісіңіз</h5>
                <div class="socials flex-row">
                    <ShareNetwork
                        network="facebook"
                        :url="'http://shyn.kz' + $route.path"
                        title="Say hi to Vite! A brand new, extremely fast development setup for Vue."
                        description="This week, I’d like to introduce you to 'Vite', which means 'Fast'. It’s a brand new development setup created by Evan You."
                        quote="The hot reload is so fast it\'s near instant. - Evan You"
                        hashtags="vuejs,vite"
                    >
                        <svg :style="{ 'border-color' : data.impairedRegime ? '#000000' : '#568357' }" style="padding: 13px" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M24 2.66764V21.3343C24 22.0416 23.719 22.7198 23.219 23.2199C22.7189 23.72 22.0406 24.001 21.3333 24.001H16.3333C16.1565 24.001 15.987 23.9307 15.8619 23.8057C15.7369 23.6807 15.6667 23.5111 15.6667 23.3343V15.3343H18.7867C18.9404 15.3343 19.0893 15.2813 19.2084 15.1841C19.3274 15.0869 19.4093 14.9516 19.44 14.801L19.92 12.401C19.9298 12.3531 19.9289 12.3036 19.9175 12.2561C19.906 12.2086 19.8842 12.1642 19.8537 12.126C19.8232 12.0878 19.7846 12.0569 19.7408 12.0353C19.6969 12.0136 19.6489 12.0019 19.6 12.001H15.6667V7.66764C15.6667 7.57924 15.7018 7.49445 15.7643 7.43194C15.8268 7.36943 15.9116 7.33431 16 7.33431H19.3333C19.5101 7.33431 19.6797 7.26407 19.8047 7.13905C19.9298 7.01402 20 6.84445 20 6.66764V4.66764C20 4.49083 19.9298 4.32126 19.8047 4.19624C19.6797 4.07121 19.5101 4.00098 19.3333 4.00098H16C14.9391 4.00098 13.9217 4.4224 13.1716 5.17255C12.4214 5.9227 12 6.94011 12 8.00098V12.001H10.36C10.1832 12.001 10.0136 12.0712 9.8886 12.1962C9.76357 12.3213 9.69333 12.4908 9.69333 12.6676V14.6676C9.69333 14.8445 9.76357 15.014 9.8886 15.139C10.0136 15.2641 10.1832 15.3343 10.36 15.3343H12V23.3343C12 23.5111 11.9298 23.6807 11.8047 23.8057C11.6797 23.9307 11.5101 24.001 11.3333 24.001H2.66667C1.95942 24.001 1.28115 23.72 0.781048 23.2199C0.280951 22.7198 0 22.0416 0 21.3343V2.66764C0 1.9604 0.280951 1.28212 0.781048 0.782025C1.28115 0.281928 1.95942 0.000976563 2.66667 0.000976562H21.3333C22.0406 0.000976563 22.7189 0.281928 23.219 0.782025C23.719 1.28212 24 1.9604 24 2.66764Z" :fill="data.impairedRegime ? '#000000' : '#568357'"/>
                        </svg>
                    </ShareNetwork>
                    <ShareNetwork
                        network="linkedin"
                        :url="'http://shyn.kz' + $route.path"
                        title="Say hi to Vite! A brand new, extremely fast development setup for Vue."
                        description="This week, I’d like to introduce you to 'Vite', which means 'Fast'. It’s a brand new development setup created by Evan You."
                        quote="The hot reload is so fast it\'s near instant. - Evan You"
                        hashtags="vuejs,vite"
                    >
                        <svg :style="{ 'border-color' : data.impairedRegime ? '#000000' : '#568357' }" style="padding: 13.5px 12.5px" width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.00033 8.66764V22.001C6.00033 22.1778 5.93009 22.3474 5.80506 22.4724C5.68004 22.5974 5.51047 22.6676 5.33366 22.6676H2.00033C1.82352 22.6676 1.65395 22.5974 1.52892 22.4724C1.4039 22.3474 1.33366 22.1778 1.33366 22.001V8.66764C1.33366 8.49083 1.4039 8.32126 1.52892 8.19624C1.65395 8.07121 1.82352 8.00098 2.00033 8.00098H5.33366C5.51047 8.00098 5.68004 8.07121 5.80506 8.19624C5.93009 8.32126 6.00033 8.49083 6.00033 8.66764ZM24.0003 13.881C24.0226 12.4798 23.5655 11.113 22.7046 10.0072C21.8437 8.90145 20.6309 8.12302 19.267 7.80098C18.339 7.60115 17.3766 7.62639 16.4604 7.87459C15.5441 8.1228 14.7006 8.58674 14.0003 9.22764V8.66764C14.0003 8.49083 13.9301 8.32126 13.8051 8.19624C13.68 8.07121 13.5105 8.00098 13.3337 8.00098H10.0003C9.82352 8.00098 9.65395 8.07121 9.52892 8.19624C9.4039 8.32126 9.33366 8.49083 9.33366 8.66764V22.001C9.33366 22.1778 9.4039 22.3474 9.52892 22.4724C9.65395 22.5974 9.82352 22.6676 10.0003 22.6676H13.3337C13.5105 22.6676 13.68 22.5974 13.8051 22.4724C13.9301 22.3474 14.0003 22.1778 14.0003 22.001V14.481C13.9844 13.8323 14.1975 13.1987 14.6023 12.6915C15.007 12.1843 15.5776 11.836 16.2137 11.7076C16.5998 11.641 16.9959 11.6603 17.3738 11.7641C17.7516 11.8679 18.102 12.0537 18.3999 12.3083C18.6978 12.5629 18.9359 12.88 19.0973 13.2371C19.2587 13.5942 19.3394 13.9825 19.3337 14.3743V22.001C19.3337 22.1778 19.4039 22.3474 19.5289 22.4724C19.6539 22.5974 19.8235 22.6676 20.0003 22.6676H23.3337C23.5105 22.6676 23.68 22.5974 23.8051 22.4724C23.9301 22.3474 24.0003 22.1778 24.0003 22.001V13.881ZM3.33366 0.000976562C2.80624 0.000976563 2.29067 0.157374 1.85214 0.450391C1.41361 0.743408 1.07181 1.15988 0.869981 1.64715C0.668148 2.13442 0.615339 2.6706 0.718233 3.18788C0.821127 3.70517 1.0751 4.18032 1.44804 4.55326C1.82098 4.9262 2.29614 5.18018 2.81342 5.28307C3.3307 5.38596 3.86688 5.33316 4.35415 5.13132C4.84142 4.92949 5.2579 4.58769 5.55091 4.14916C5.84393 3.71063 6.00033 3.19506 6.00033 2.66764C6.00033 1.9604 5.71938 1.28212 5.21928 0.782025C4.71918 0.281928 4.0409 0.000976563 3.33366 0.000976562Z" :fill="data.impairedRegime ? '#000000' : '#568357'"/>
                        </svg>
                    </ShareNetwork>
                    <ShareNetwork
                        network="twitter"
                        :url="'http://shyn.kz' + $route.path"
                        title="Say hi to Vite! A brand new, extremely fast development setup for Vue."
                        description="This week, I’d like to introduce you to 'Vite', which means 'Fast'. It’s a brand new development setup created by Evan You."
                        quote="The hot reload is so fast it\'s near instant. - Evan You"
                        hashtags="vuejs,vite"
                    >
                        <svg :style="{ 'border-color' : data.impairedRegime ? '#000000' : '#568357' }" style="padding: 12px 9px" width="32" height="26" viewBox="0 0 32 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M32 3.00098C30.8 3.60098 29.6 3.80098 28.2 4.00098C29.6 3.20098 30.6 2.00098 31 0.400977C29.8 1.20098 28.4 1.60098 26.8 2.00098C25.6 0.800977 23.8 0.000976562 22 0.000976562C18.6 0.000976562 15.6 3.00098 15.6 6.60098C15.6 7.20098 15.6 7.60098 15.8 8.00098C10.4 7.80098 5.4 5.20098 2.2 1.20098C1.6 2.20098 1.4 3.20098 1.4 4.60098C1.4 6.80098 2.6 8.80098 4.4 10.001C3.4 10.001 2.4 9.60098 1.4 9.20098C1.4 12.401 3.6 15.001 6.6 15.601C6 15.801 5.4 15.801 4.8 15.801C4.4 15.801 4 15.801 3.6 15.601C4.4 18.201 6.8 20.201 9.8 20.201C7.6 22.001 4.8 23.001 1.6 23.001H0C3 24.801 6.4 26.001 10 26.001C22 26.001 28.6 16.001 28.6 7.40098V6.60098C30 5.60098 31.2 4.40098 32 3.00098Z" :fill="data.impairedRegime ? '#000000' : '#568357'"/>
                        </svg>
                    </ShareNetwork>
                    <ShareNetwork
                        network="facebook"
                        :url="'http://shyn.kz' + $route.path"
                        title="Say hi to Vite! A brand new, extremely fast development setup for Vue."
                        description="This week, I’d like to introduce you to 'Vite', which means 'Fast'. It’s a brand new development setup created by Evan You."
                        quote="The hot reload is so fast it\'s near instant. - Evan You"
                        hashtags="vuejs,vite"
                    >
                        <svg :style="{ 'border-color' : data.impairedRegime ? '#000000' : '#568357' }" style="padding: 9px" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.2901 9.70426C25.3505 9.70426 26.2101 8.84464 26.2101 7.78426C26.2101 6.72387 25.3505 5.86426 24.2901 5.86426C23.2297 5.86426 22.3701 6.72387 22.3701 7.78426C22.3701 8.84464 23.2297 9.70426 24.2901 9.70426Z" :fill="data.impairedRegime ? '#000000' : '#568357'"/>
                            <path d="M16 24.001C11.588 24.001 8 20.413 8 16.001C8 11.589 11.588 8.00098 16 8.00098C20.412 8.00098 24 11.589 24 16.001C24 20.413 20.412 24.001 16 24.001ZM16 12.001C13.794 12.001 12 13.795 12 16.001C12 18.207 13.794 20.001 16 20.001C18.206 20.001 20 18.207 20 16.001C20 13.795 18.206 12.001 16 12.001Z" :fill="data.impairedRegime ? '#000000' : '#568357'"/>
                            <path d="M24 32.001H8C3.888 32.001 0 28.113 0 24.001V8.00098C0 3.88898 3.888 0.000976562 8 0.000976562H24C28.112 0.000976562 32 3.88898 32 8.00098V24.001C32 28.113 28.112 32.001 24 32.001ZM8 4.00098C6.13 4.00098 4 6.13098 4 8.00098V24.001C4 25.907 6.094 28.001 8 28.001H24C25.87 28.001 28 25.871 28 24.001V8.00098C28 6.13098 25.87 4.00098 24 4.00098H8Z" :fill="data.impairedRegime ? '#000000' : '#568357'"/>
                        </svg>
                    </ShareNetwork>
                </div>
                <h5 v-if="lang === 'ru'" class="copy-link-text">Или скопируйте ссылку</h5>
                <h5 v-if="lang === 'kk'" class="copy-link-text">Немесе сілтемені көшіріңіз</h5>
                <div class="copy-btns flex-row">
                    <input :style="{ 'border-color' : data.impairedRegime ? '#000000' : '#568357' }" id="linkCopy" type="text" :value="'http://shyn.kz' + $route.path" readonly>
                    <span v-if="lang === 'ru'" @click="copyLink()" :style="{ 'background' : data.impairedRegime ? 'rgba(0,0,0,0.6)' : '#F0DCC4', 'color' : data.impairedRegime ? '#ffffff' : '#568357'}">Скопировать</span>
                    <span v-if="lang === 'kk'" @click="copyLink()" :style="{ 'background' : data.impairedRegime ? 'rgba(0,0,0,0.6)' : '#F0DCC4', 'color' : data.impairedRegime ? '#ffffff' : '#568357'}">Көшіру</span>
                </div>
            </div>
        </div>
        <directory :route="$route"></directory>
        <!-- <div v-if="dataNews" :style="{ 'background' : data.impairedRegime ? 'rgba(0,0,0,0.4)' : '#EB5757' }" class="tag">{{ dataIncluded.find( item => item.id === dataNews.relationships.field_tags.data.find( x => x.id !== 'f2a351e1-6046-4d61-823d-25fb6e965225' ).id ).attributes.name }}</div> -->
        <div class="title">
            <h1 :style="{ 'color' : data.impairedRegime ? '#000000' : '#568357' }">{{ dataNews.attributes.title }}</h1>
            <div @click="showModal = true;" :style="{ 'background' : data.impairedRegime ? 'rgba(0,0,0,0.6)' : '#ffffff', 'color' : data.impairedRegime ? '#ffffff' : '#568357'}" class="share flex-row">
                <svg style="margin-top: 4px;" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18.5279 3.33328C18.5279 4.8291 17.3154 6.04172 15.8196 6.04172C14.3238 6.04172 13.1113 4.8291 13.1113 3.33328C13.1113 1.83762 14.3238 0.625 15.8196 0.625C17.3154 0.625 18.5279 1.83762 18.5279 3.33328Z" :fill="data.impairedRegime ? '#ffffff' : '#568357'"/>
                    <path d="M15.8196 6.66672C13.9812 6.66672 12.4863 5.17166 12.4863 3.33328C12.4863 1.49506 13.9812 0 15.8196 0C17.658 0 19.1529 1.49506 19.1529 3.33328C19.1529 5.17166 17.658 6.66672 15.8196 6.66672ZM15.8196 1.25C14.6705 1.25 13.7363 2.18506 13.7363 3.33328C13.7363 4.48166 14.6705 5.41672 15.8196 5.41672C16.9688 5.41672 17.9029 4.48166 17.9029 3.33328C17.9029 2.18506 16.9688 1.25 15.8196 1.25Z" :fill="data.impairedRegime ? '#ffffff' : '#568357'"/>
                    <path d="M18.5279 16.6669C18.5279 18.1626 17.3154 19.3752 15.8196 19.3752C14.3238 19.3752 13.1113 18.1626 13.1113 16.6669C13.1113 15.1711 14.3238 13.9585 15.8196 13.9585C17.3154 13.9585 18.5279 15.1711 18.5279 16.6669Z" :fill="data.impairedRegime ? '#ffffff' : '#568357'"/>
                    <path d="M15.8196 20.0002C13.9812 20.0002 12.4863 18.5052 12.4863 16.6669C12.4863 14.8286 13.9812 13.3335 15.8196 13.3335C17.658 13.3335 19.1529 14.8286 19.1529 16.6669C19.1529 18.5052 17.658 20.0002 15.8196 20.0002ZM15.8196 14.5835C14.6705 14.5835 13.7363 15.5186 13.7363 16.6669C13.7363 17.8152 14.6705 18.7502 15.8196 18.7502C16.9688 18.7502 17.9029 17.8152 17.9029 16.6669C17.9029 15.5186 16.9688 14.5835 15.8196 14.5835Z" :fill="data.impairedRegime ? '#ffffff' : '#568357'"/>
                    <path d="M6.86203 9.99979C6.86203 11.4956 5.64941 12.7081 4.15359 12.7081C2.65793 12.7081 1.44531 11.4956 1.44531 9.99979C1.44531 8.50397 2.65793 7.2915 4.15359 7.2915C5.64941 7.2915 6.86203 8.50397 6.86203 9.99979Z" :fill="data.impairedRegime ? '#ffffff' : '#568357'"/>
                    <path d="M4.15359 13.3331C2.31537 13.3331 0.820312 11.8382 0.820312 9.99979C0.820312 8.16141 2.31537 6.6665 4.15359 6.6665C5.99197 6.6665 7.48703 8.16141 7.48703 9.99979C7.48703 11.8382 5.99197 13.3331 4.15359 13.3331ZM4.15359 7.9165C3.00446 7.9165 2.07031 8.85141 2.07031 9.99979C2.07031 11.1482 3.00446 12.0831 4.15359 12.0831C5.30289 12.0831 6.23703 11.1482 6.23703 9.99979C6.23703 8.85141 5.30289 7.9165 4.15359 7.9165Z" :fill="data.impairedRegime ? '#ffffff' : '#568357'"/>
                    <path d="M6.12127 9.59998C5.8312 9.59998 5.54953 9.44907 5.39618 9.17915C5.16867 8.77998 5.30874 8.27079 5.70791 8.04237L13.4403 3.6341C13.8395 3.40492 14.3487 3.54499 14.5771 3.94569C14.8046 4.34486 14.6645 4.85404 14.2653 5.08247L6.5328 9.49073C6.4028 9.56489 6.2612 9.59998 6.12127 9.59998Z" :fill="data.impairedRegime ? '#ffffff' : '#568357'"/>
                    <path d="M13.852 16.4753C13.7119 16.4753 13.5703 16.4402 13.4403 16.3661L5.7078 11.9578C5.30863 11.7303 5.16871 11.2211 5.39621 10.821C5.62281 10.4211 6.13275 10.2802 6.53284 10.5094L14.2654 14.9177C14.6645 15.1452 14.8045 15.6544 14.577 16.0545C14.4228 16.3244 14.1412 16.4753 13.852 16.4753Z" :fill="data.impairedRegime ? '#ffffff' : '#568357'"/>
                </svg>
                <span v-if="dataNews && lang === 'ru'">Поделиться</span>
                <span v-if="dataNews && lang === 'kk'">Бөлісу</span>
            </div>
        </div>
        <p :style="{ 'filter' : data.impairedRegime ? 'grayscale(1)' : 'grayscale(0)', '-webkit-filter' : data.impairedRegime ? 'grayscale(1)' : 'grayscale(0)' }" class="page-content text-body" v-html="dataNews.attributes.field_description.value"></p>
        
        <div class="date flex-row">
            <span v-if="lang === 'ru'">Дата публикации:</span>
            <span v-if="lang === 'kk'">Жарияланған күні:</span>
            <div class="date-value">{{ formatDateTime(dataNews.attributes.created) }}</div>
        </div>
        <!-- <div class="source flex-row">
            <span v-if="lang === 'ru'">Источник:</span>
            <span v-if="lang === 'kk'">Дереккөз:</span>
            <div class="date-value">{{ dataIncluded.find( item => item.id === dataNews.relationships.uid.data.id ).attributes.name }}</div>
        </div> -->
    </div>
</div>
</template>
<script>
import axios from 'axios'
import { func, api } from '../../variables.js'

export default {
    props: [ 'data' ],
    data() {
        return {
            showModal: false,
            dataNews: '',
            dataIncluded: '',
            lang: 'kk',
            loading: false
        }
    },
    created: function () {
        if( localStorage.getItem('xyzCustomLang') ){
			this.lang = localStorage.getItem('xyzCustomLang')
		}
        window.scrollTo(0,0)
        this.getArticle()
    },
    methods: {
        getArticle(){
            this.loading = true
            axios.get( api + '/mhealth/jsonapi/node/srh_content/' + this.$route.params.id + '/?include=uid,uid.user_picture,field_cover_image,field_tags' )
            .then((res) => {
                console.log(res.data.data)
                this.dataNews = res.data.data
                this.dataIncluded = res.data.included
                this.dataNews.attributes.field_description.value = this.dataNews.attributes.field_description.value.replaceAll('/mhealth/sites/default/files', api + '/mhealth/sites/default/files');
                this.loading = false
            })
            .catch((e) => {
                this.loading = false
                console.log('Error in loading news\n' + e)
            })
        },
        copyLink(){
            var copyText = document.getElementById("linkCopy")
            copyText.select();
            document.execCommand('copy')
            alert("Ссылка успешна скопирована.")
        },
        formatDateTime: func.formatDateTime,
    }
}
</script>
<style lang="scss" scoped>
    *{
        transition: all 0.6s ease;
    }
    span, h1, h3, p, .page-info, li{
        cursor: default;
        margin: 0;
        text-align: left;
    }
    .outer{
        padding: 30px 16% 94px 16%;
        transition: none;
        .title{
            margin-top: 30px;
            position: relative;
            h1{
                font-weight: bold;
                font-size: 34px;
                line-height: 45px;
                letter-spacing: 0.04em;
                color: #568357;
                width: 75%; 
            }
            .share{
                cursor: pointer;
                position: absolute;
                top: -4px;
                right: 0;
                padding: 15px 53px;
                background: #FFFFFF;
                border-radius: 10px;
                span{
                    cursor: pointer;
                    margin-left: 10px;
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 26px;
                    text-align: center;
                    letter-spacing: 0.04em;
                }
            }
        }
        .tag{
            margin-top: 10px;
            padding: 7px 16px;
            width: 220px;
            box-shadow: 5px 10px 20px rgba(179, 189, 201, 0.2);
            border-radius: 10px;
            font-weight: 300;
            font-size: 16px;
            line-height: 26px;
            letter-spacing: 0.04em;
            color: #FFFFFF;
        }
        .text-body{
            margin-top: 24px;
            font-weight: 300;
            font-size: 22px;
            line-height: 25px;
            letter-spacing: 0.03em;
        }
        .date, .source{
            margin-top: 30px;
            span{
                font-weight: 300;
                font-size: 18px;
                line-height: 45px;
                letter-spacing: 0.04em;
            }
            .date-value{
                cursor: default;
                margin-left: 5px;
                font-weight: 500;
                font-size: 18px;
                line-height: 45px;
                letter-spacing: 0.04em;
            }
        }
        .source{
            margin-top: 10px;
        }
    }
    .modal{
        position: fixed; /* Stay in place */
        z-index: 1; /* Sit on top */
        left: 0;
        top: 0;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background: rgba(51, 51, 51, 0.4);  
        .modal-content {
            position: relative;
            background: #FFFFFF;
            box-shadow: 5px 10px 50px rgba(16, 112, 177, 0.2);
            border-radius: 10px;
            margin: 145px auto auto auto;
            padding: 30px 40px;
            width: 460px;
            h5{
                margin: 0;
                text-align: left;
                font-weight: 500;
                font-size: 20px;
                line-height: 156.61%;
                letter-spacing: -0.44px;
            }
            .socials{
                margin: 50px 50px 0 50px;
                svg{
                    cursor: pointer;
                    border: 1px solid #568357;
                    border-radius: 5px;
                    margin: 0 20px;
                }
            }
            .copy-link-text{
                margin-top: 100px;
            }
            .copy-btns{
                input{
                    width: 304px;
                    background: #FFFFFF;
                    border: 1px solid #568357;
                    border-radius: 10px;
                    padding: 10px;
                    font-weight: 500;
                    font-size: 12px;
                    line-height: 30px;
                    letter-spacing: 0.04em;
                    color: #333333;
                    opacity: 0.6;
                }
                span{
                    cursor: pointer;
                    margin-left: 7px;
                    width: 159px;
                    border-radius: 10px;
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 56px;
                    text-align: center;
                    letter-spacing: 0.04em;
                }
            }
        }
    }
    @media only screen and (max-width: 1330px){
        .outer{
            padding: 30px 12% 94px 12%;
            .title{
                h1{
                    width: 100%;
                }
                .share{
                    display: none;
                }
            }
        }
    }
    @media only screen and (max-width: 1024px){
        .outer{
            padding: 20px 12% 72px 12%;
            .title{
                margin-top: 20px;
                position: relative;
                h1{
                    font-weight: bold;
                    font-size: 32px;
                    line-height: 38px;
                    letter-spacing: 0.04em;
                    color: #568357;
                }
                .share{
                    cursor: pointer;
                    position: absolute;
                    top: -4px;
                    right: 0;
                    padding: 8px 40px;
                    background: #FFFFFF;
                    border-radius: 10px;
                    span{
                        cursor: pointer;
                        margin-left: 10px;
                        font-weight: 500;
                        font-size: 16px;
                        line-height: 26px;
                        text-align: center;
                        letter-spacing: 0.04em;
                    }
                }
            }
            .tag{
                margin-top: 10px;
                padding: 4px 12px;
                width: 180px;
                box-shadow: 5px 10px 20px rgba(179, 189, 201, 0.2);
                border-radius: 10px;
                font-weight: 300; 
                font-size: 16px;
                line-height: 26px;
                letter-spacing: 0.04em;
                color: #FFFFFF;
            }
            .text-body{
                margin-top: 10px;
                font-weight: 300;
                font-size: 22px;
                line-height: 25px;
                letter-spacing: 0.03em;
            }
            .date, .source{
                margin-top: 10px;
                span{
                    font-weight: 300;
                    font-size: 18px;
                    line-height: 45px;
                    letter-spacing: 0.04em;
                }
                .date-value{
                    cursor: default;
                    margin-left: 5px;
                    font-weight: 500;
                    font-size: 18px;
                    line-height: 45px;
                    letter-spacing: 0.04em;
                }
            }
            .source{
                margin-top: 0px;
            }
        } 
    }
    @media only screen and (max-width: 720px){
        .outer{
            padding: 20px 6% 72px 6%;
            .title{
                margin-top: 10px;
                position: relative;
                h1{
                    // margin-top: 20px;
                    font-weight: bold;
                    font-size: 28px;
                    line-height: 38px;
                    letter-spacing: 0.04em;
                    color: #568357;
                }
                .share{
                    cursor: pointer;
                    position: absolute;
                    top: 0px;
                    right: auto;
                    left: 0;
                    padding: 6px 30px;
                    background: #FFFFFF;
                    border-radius: 10px;
                    span{
                        cursor: pointer;
                        margin-left: 10px;
                        font-weight: 500;
                        font-size: 16px;
                        line-height: 26px;
                        text-align: center;
                        letter-spacing: 0.04em;
                    }
                }
            }
            .tag{
                margin-top: 10px;
                padding: 2px 10px;
                width: 164px;
                box-shadow: 5px 10px 20px rgba(179, 189, 201, 0.2);
                border-radius: 10px;
                font-weight: 300; 
                font-size: 16px;
                line-height: 26px;
                letter-spacing: 0.04em;
                color: #FFFFFF;
            }
            .text-body{
                margin-top: 0px;
                font-weight: 300;
                font-size: 22px;
                line-height: 25px;
                letter-spacing: 0.03em;
            }
            .date, .source{
                margin-top: 10px;
                span{
                    font-weight: 300;
                    font-size: 16px;
                    line-height: 32px;
                    letter-spacing: 0.04em;
                }
                .date-value{
                    cursor: default;
                    margin-left: 5px;
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 32px;
                    letter-spacing: 0.04em;
                }
            }
            .source{
                margin-top: 0px;
            }
        } 
        .modal{
            .modal-content {
                position: relative;
                background: #FFFFFF;
                box-shadow: 5px 10px 50px rgba(16, 112, 177, 0.2);
                border-radius: 10px;
                margin: 145px auto auto auto;
                padding: 20px 15px;
                width: 290px;
                svg{
                    top: 30px !important;
                    right: 20px !important;
                }
                h5{
                    width: 240px;
                    margin: 0;
                    text-align: left;
                    font-weight: 500;
                    font-size: 18px;
                    line-height: 24px;
                    letter-spacing: -0.44px;
                }
                .socials{
                    margin: 30px 0px 0 0px;
                    svg{
                        cursor: pointer;
                        border: 1px solid #568357;
                        border-radius: 5px;
                        margin: 0 10px;
                    }
                }
                .copy-link-text{
                    margin-top: 20px;
                }
                .copy-btns{
                    margin-top: 10px;
                    flex-direction: column;
                    input{
                        width: calc(100% - 30px);
                        background: #FFFFFF;
                        border: 1px solid #568357;
                        border-radius: 10px;
                        padding:  8px 10px;
                        font-weight: 500;
                        font-size: 12px;
                        line-height: 30px;
                        letter-spacing: 0.04em;
                        color: #333333;
                        opacity: 0.6;
                    }
                    span{
                        cursor: pointer;
                        margin-top: 10px;
                        margin-left: 66px;
                        width: 160px;
                        border-radius: 10px;
                        font-weight: 500;
                        font-size: 16px;
                        line-height: 42px;
                        text-align: center;
                        letter-spacing: 0.04em;
                    }
                }
            }
        }
    }
    @media only screen and (max-width: 480px){
        .outer{
            padding: 20px 4% 48px 4%;
        } 
    }
</style>


